const baseUrl = process.env.BASE_URL || '/';
const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
const PDFJS_WASM_URL = `${normalizedBaseUrl}pdfjs/wasm/`;

export function createPdfSource(data) {
    const source = data instanceof Uint8Array
        ? data
        : new Uint8Array(data);

    return {
        data: source,
        wasmUrl: PDFJS_WASM_URL,
    };
}
